(ns machtfit.product-form.views
  (:require [machtfit.dashboard-widgets :as widgets]
            [machtfit.product-form.core :as product-form]
            [machtfit.product-form.for-whom :refer [section-for-whom]]
            [machtfit.product-form.handlers :as handlers]
            [machtfit.product-form.how :refer [section-how]]
            [machtfit.product-form.how-much :refer [section-how-much]]
            [machtfit.product-form.navigation :as navigation]
            [machtfit.product-form.promotions :refer [section-promotions]]
            [machtfit.product-form.resale-info :refer [section-resale-info]]
            [machtfit.product-form.section :as section]
            [machtfit.product-form.visibility :refer [section-visibility]]
            [machtfit.product-form.what :refer [section-what]]
            [machtfit.product-form.when :refer [section-when]]
            [machtfit.product-form.where :refer [section-where]]
            [machtfit.product-form.who :refer [section-who]]
            [re-frame.core :as rf]))

;; Ideen und Vorschläge
;;
;; * online: :when termin-unabhängig immer, oder Zeitraum; Termingebunden oder
;;   nicht
;; * erst Kategorie-Auswahl vor Bildauswahl ermöglicht Standardbild (oder
;;   random) pro Kategorie, was super wäre, und kann auch Bilderbibliothek
;;   beeinflussen (Elmar)
;; * Alternativ kann die Bilderbibliothek nach Kategorien organisiert sein und
;;   eine Bildauswähl selektiert dann eine Kategorie vor (Gregor)
;; * "Ändern" klingt wie ein Imperativ (Elmar)
;; * Perspektive Gesundheitsmanager: Option Ort :area weg (Elmar)
;; * Allgemein weniger Text wenn möglich (Caro & Cedric)
;; * Wording: Kurse bestehen aus Durchläufen
;; * Wenn min-teilnehmerzahl vorausgefüllt wird, focus + select all (Gregor)
;; * Zertifikatskarte ist zu hoch -> Titel und Button überblenden
;; * Bei widgets/choice keywords der Auswahlmöglichkeiten fett hervorheben.
;;   Weiterhin ggfs die nicht ausgewählte Choice etwas ausgrauen
;; * Wording: Präsenzangebot (anstelle von Offline-(nicht-online) Angebot)
;; * Section-showing: never hide section if a following section is shown
;; * Buß- und Bett-AG berechnen bei Datumsfeldern
;;
;; Als nächstes:
;;
;; * Weniger erschlagend am Anfang (Abschnitte erscheinen bei neuen Produkten
;;   nacheinander) (Caro & Cedric)
;;
;; Umgesetzt:
;; * Text bei weekdays weniger (Caro & Cedric)

(defn- section-errors []
  [widgets/section
   {:title "Fehler"
    :subtitle "Bitte korrigieren Sie:"
    :content [:div>div.col.s11.offset-s1
              [widgets/error-messages @(rf/subscribe [:get [:errors]])]]}])

(defn- section-save []
  (let [state @(rf/subscribe [:get [:product :state]])
        product-needs-verification? @(rf/subscribe [:get [:options :product-needs-verification?]])
        publish? @(rf/subscribe [:get [:ui :publish?]])
        can-save-only? @(rf/subscribe [:get [:options :can-save-only?]])
        cancel-url @(rf/subscribe [:get [:ui :cancel-url]])
        content-too-big? @(rf/subscribe [::product-form/content-too-big?])]
    [widgets/section
     {:anchor "save"
      :title "Danke"
      :subtitle "für Ihre Mithilfe!"
      :content [:div
                [:div.col.s12>p (if product-needs-verification?
                                  (case state
                                    :new nil ; no text for new offers - no explanation needed here
                                    :review "Das Angebot wird gerade von machtfit geprüft und dann veröffentlicht."
                                    :rejected "Das Angebot wurde geprüft, konnte aber nicht veröffentlicht werden. Sie haben dazu eine E-Mail erhalten."
                                    :published "Das Angebot ist veröffentlicht."
                                    :deactivated "Das Angebot ist für Mitarbeiter nicht sichtbar."
                                    :archived "Das Angebot ist archiviert."
                                    nil)
                                  (case state
                                    :new nil ; no text for new offers - no explanation needed here
                                    :deactivated "Das Angebot ist für Mitarbeiter nicht sichtbar."
                                    :published "Das Angebot ist für Mitarbeiter sichtbar."
                                    :archived "Das Angebot ist archiviert."))]
                [:div.col.s8
                 (if content-too-big?
                   [:button.btn {:disabled true} "Speichern"]
                   [:a.waves-effect.waves-light.btn
                    {:on-click #(rf/dispatch [::handlers/save])}
                    "Speichern"])

                 (when-not can-save-only?
                   [:span {:style {:padding-left "1rem" :line-height "36px"}} ;; Same as .btn, so the text appears on the same height
                    [:input.filled-in {:id "publish?"
                                       :type "checkbox"
                                       :checked publish?
                                       :on-change #(rf/dispatch [:toggle [:ui :publish?]])}]
                    [:label {:for "publish?" :style {:color "black"}}
                     (if (= :archived state)
                       "Angebot wiederherstellen"
                       "Angebot veröffentlichen")]])]
                (when cancel-url [:div.col.s4
                                  [:button.waves-effect.btn.btn-flat
                                   {:on-click #(rf/dispatch [::handlers/cancel])}
                                   [:i.material-icons.left "cancel"] "Abbrechen"]])
                [:div.col.s12>p (when-not can-save-only?
                                  (get-in
                                   {:company {:new {:not-checked "Nach dem Speichern ist das Angebot für Mitarbeiter nicht sichtbar."
                                                    :checked "Das Angebot wird veröffentlicht und Mitarbeiter können das Angebot sehen."}
                                              :deactivated {:checked "Das Angebot wird veröffentlicht und Mitarbeiter können das Angebot sehen."
                                                            :not-checked "Nach dem Speichern ist das Angebot für Mitarbeiter nicht sichtbar."}
                                              :published {:not-checked "Nach dem Speichern ist das Angebot für Mitarbeiter nicht mehr sichtbar."
                                                          :checked "Nach dem Speichern können Mitarbeiter die Änderungen sofort sehen."}
                                              :archived {:not-checked "Das Angebot bleibt archiviert."
                                                         :checked "Das Angebot wird wiederhergestellt. Sie können es danach veröffentlichen."}}
                                    :partner {:new {:checked "Das Angebot wird nach Prüfung durch machtfit veröffentlicht und ist dann buchbar."
                                                    :not-checked (str "Das Angebot wird nur gespeichert und ist für Mitarbeiter nicht sichtbar."
                                                                      " Damit Mitarbeiter das Angebot buchen können, müssen Sie es veröffentlichen.")}
                                              :review {:checked "Das Angebot wird nach Prüfung Ihrer Änderungen durch machtfit veröffentlicht und ist dann buchbar."
                                                       :not-checked "Nach dem Speichern wird das Angebot nicht geprüft und nicht veröffentlicht."}
                                              :rejected {:checked "Das Angebot wird nach erneuter Prüfung durch machtfit veröffentlicht und ist dann buchbar."
                                                         :not-checked "Das Angebot bleibt für Mitarbeiter nicht sichtbar. Damit Mitarbeiter das Angebot buchen können, müssen Sie es veröffentlichen."}
                                              :published {:checked "Das Angebot wird nach erneuter Prüfung durch machtfit veröffentlicht und ist dann buchbar."
                                                          :not-checked "Nach dem Speichern ist das Angebot für Mitarbeiter nicht mehr sichtbar."}
                                              :deactivated {:checked "Das Angebot wird nach Prüfung durch machtfit veröffentlicht und ist dann buchbar."
                                                            :not-checked "Das Angebot bleibt für Mitarbeiter nicht sichtbar. Damit Mitarbeiter das Angebot buchen können, muss es veröffentlicht werden."}
                                              :archived {:not-checked "Das Angebot bleibt archiviert."
                                                         :checked "Das Angebot wird wiederhergestellt. Sie können es danach veröffentlichen."}}}
                                   [(if product-needs-verification? :partner :company)
                                    state
                                    (if publish? :checked :not-checked)]))]]}]))

(defn product-edit []
  (let [view-map {:errors section-errors
                  :what section-what
                  :where section-where
                  :when section-when
                  :for-whom section-for-whom
                  :who section-who
                  :how section-how
                  :resale-info section-resale-info
                  :how-much section-how-much
                  :visibility section-visibility
                  :promotions section-promotions
                  :save section-save}]
    (-> [:div.container {:style {:width "95%"}}
         [navigation/navigation]]

        (into (interpose [:div.divider]
                         (map #(vector (view-map %)) @(rf/subscribe [::section/visible-sections])))))))
